import { useEffect } from 'react';

/**
 * index.html mounts React into `<body id="root">`, and the Zooza stylesheets lay
 * that same body out as a sidebar grid — from two directions:
 *
 *  - `scss/_v2_grid.scss` styles bare `body` as `160px auto`, no class needed;
 *  - the Z2 sheet adds `200px 1fr` for `app_body_layout default_sidebar`.
 *
 * So a screen with no sidebar of its own is dropped into the sidebar column and
 * collapses to ~160px. Removing classes is not enough — the bare `body` rule
 * survives it — hence `message_layout`, which resets the body back to a block.
 */
const APP_CLASSES = ['z2', 'app_body_layout', 'default_sidebar'];
const PLAIN_CLASSES = ['message_layout'];

export type BodyLayout = 'app' | 'plain';

export function useBodyLayout(layout: BodyLayout) {
    useEffect(() => {
        const body = document.body;

        if (layout === 'app') {
            body.classList.remove(...PLAIN_CLASSES);
            body.classList.add(...APP_CLASSES);
        } else {
            body.classList.remove(...APP_CLASSES);
            body.classList.add(...PLAIN_CLASSES);
        }

        return () => {
            body.classList.remove(...APP_CLASSES, ...PLAIN_CLASSES);
        };
    }, [layout]);
}
